export const returnPhaseText = phase => {

  if (phase===2 || phase === 3 || phase === 4|| phase === 5) return 'Live'
  if (phase === 1) return 'Draft'
  if (phase === 21) return 'scheduled'
  if (phase === 7|| phase === 10|| phase === 8) return 'Completed'

}